// Translation: Utility > Loading error (Ukrainian)
export default Object.freeze({
	description: '',
	title: ''
})
